import {AUTH_TOKEN} from './serve/consts';
import {get, remove, set} from './serve/localStorage';

export function getAuthToken() {
  return get<string>(AUTH_TOKEN);
}

export function removeAuthToken() {
  remove(AUTH_TOKEN);
}

export function setAuthToken(token: string) {
  set(AUTH_TOKEN, token);
}
